<div appFlexLayout="column" appFlex fusePerfectScrollbar>

    <mat-list class="date" cdkFocusRegionStart>

        <h3 matListItemMeta cdkFocusInit>
            <span>Today</span>
        </h3>

        <div class="secondary-text mat-headline-4 mb-0 p-16">
            <div class="mb-12">
                {{date | date:'EEEE'}}
            </div>
            <div appFlexLayout="row" appFlexAlign="start start">
                <span> {{date | date:'d'}}</span>
                <span class="mat-body-1">th</span>
                <span> {{date | date:'MMMM'}}</span>
            </div>
        </div>
    </mat-list>

    <mat-divider cdkFocusRegionEnd></mat-divider>

    <mat-list>
        <h3 matListItemMeta>
            <span>Events</span>
        </h3>

        <mat-list-item *ngFor="let event of events">
            <h3 matListItemTitle>{{event.title}}</h3>
            <p matListItemLine class="secondary-text">{{event.detail}}</p>
        </mat-list-item>
    </mat-list>

    <mat-divider></mat-divider>

    <mat-list>
        <h3 matListItemMeta>
            <span>Notes</span>
        </h3>

        <mat-list-item *ngFor="let note of notes">
            <h3 matListItemTitle>{{note.title}}</h3>
            <p matListItemLine class="secondary-text">{{note.detail}}</p>
        </mat-list-item>
    </mat-list>

    <mat-divider></mat-divider>

    <mat-list>
        <h3 matListItemMeta>
            <span>Quick Settings</span>
        </h3>

        <mat-list-item>
            <mat-slide-toggle appFlex class="mat-primary" [(ngModel)]="settings.notify" aria-label="Notifications"
                labelPosition="before">
                <h3>Notifications</h3>
            </mat-slide-toggle>
        </mat-list-item>

        <mat-list-item>
            <mat-slide-toggle appFlex class="mat-accent" [(ngModel)]="settings.cloud" aria-label="Cloud"
                labelPosition="before">
                <h3>Cloud Sync</h3>
            </mat-slide-toggle>
        </mat-list-item>

        <mat-list-item>
            <mat-slide-toggle appFlex class="mat-warn" [(ngModel)]="settings.retro" aria-label="Retro Thrusters"
                labelPosition="before">
                <h3>Retro Thrusters</h3>
            </mat-slide-toggle>
        </mat-list-item>
    </mat-list>

</div>